import { $ } from '../../platform/dom';
import { elOver, elStart } from '../../platform/dom';
import { META } from '../../platform/storage';
import { STATE } from '../../sim/fx';
import { startCamIntro } from '../../sim/cam-intro';
import { closeHangar, openHangar } from '../hangar';
import { openCodex } from '../codex';
import { startRun } from '../hud';
import { RUN_CFG, closeBrief, openBrief } from './brief';
import { openSettings } from './settings';
import { registerScreen } from './router';
/* ============================================================
   標題畫面（2026-08-05 重做）
   ============================================================

   舊版把標題、機體選擇、按鍵表、四顆按鈕、畫質、音量、局外統計**全部**
   堆在同一張面板上，1280 下佔滿整個左半邊而右半邊全空。

   新版只留兩件事：品牌（標題 + 背景那台自轉的機體）與四個入口。
   其餘各自搬到它該去的地方 ——
     機體選擇、種子 → 任務簡報（`screens/brief.ts`）
     畫質、音量、按鍵表 → 設定（`screens/settings.ts`）

   選單是垂直清單而不是一排按鈕：AC6 的主選單是清單，而且清單天生支援
   「上下鍵移動＋Enter」的鍵盤導航（`screens/router.ts`）。 */

var ITEMS = [
  { id: 'miStart', k: '01', n: '開始作戰', d: '選擇任務與機體' },
  { id: 'miHangar', k: '02', n: '機庫', d: '安裝局外部件、看機體' },
  { id: 'miCodex', k: '03', n: '敵人圖鑑', d: '已遭遇的機種與 BOSS' },
  { id: 'miSet', k: '04', n: '設定', d: '畫面 · 音效 · 操作' },
];

export function renderStart() {
  var m = $('mainMenu');
  if (m) {
    m.innerHTML = ITEMS.map(function (it) {
      return '<button class="mItem focusable" id="' + it.id + '">' +
        '<span class="mNum">' + it.k + '</span>' +
        '<span class="mName">' + it.n + '</span>' +
        '<span class="mDesc">' + it.d + '</span></button>';
    }).join('');
    bind();
  }
  var meta = $('metaLine');
  if (meta) {
    meta.textContent = '累計擊墜 ' + META.kills + ' · 最遠 STAGE ' + (META.bestStage || 0)
      + ' · 起始復活 ' + META.revives + (META.tier2 ? ' · 高階模組已解禁' : '');
  }
}

function show() { elStart.classList.add('show'); }

function bind() {
  on('miStart', function () { openBrief(launch, backToStart); });
  on('miHangar', function () { openHangar(); });
  on('miCodex', function () { openCodex('start'); });
  on('miSet', function () { openSettings('screenStart'); });
}
function on(id: string, fn: () => void) {
  var el = $(id); if (el) el.addEventListener('click', fn);
}

/* `startCamIntro` 要排在 `startRun` **之前**：出擊過場的起點是「按下去那一刻
   的展示鏡頭」，而 `startRun` 會走到 `resetCamera()` 把 FOV 換成戰場預設值。 */
function launch(mech: string, seed: number) { closeBrief(); startCamIntro(); startRun(mech, seed); }
function backToStart() { closeBrief(); renderStart(); show(); }

var wired = false;

/** 開機時接一次。畫面之間的導覽全部在這個檔，`ui/hud.ts` 只留對局中的 HUD。 */
export function initStartScreen() {
  renderStart();
  if (wired) return;
  wired = true;
  registerScreen({ id: 'screenStart' });
  /* 機庫的返回與「直接出擊」：機庫改了裝備之後**標題頁的局外統計會變**，
     所以回來要重畫一次。 */
  on('btnHangarBack', function () { closeHangar(); renderStart(); });
  on('btnHangarStart', function () { closeHangar(); startCamIntro(); startRun(RUN_CFG.mech, RUN_CFG.seed); });
  /* 結算畫面的兩顆（批 3 會整個重做這個畫面，這裡先讓它們可用）。 */
  on('btnRetry', function () { renderStart(); elOver.classList.remove('show'); show(); });
  on('btnSame', function () { startRun(RUN_CFG.mech, STATE.seed); });
}
